import { Dayjs } from 'dayjs';

// Declaration order is the shared display order: hours through years, then special ranges.
export enum JobDashboardRange {
  LAST_1_HOURS = 'last_1_hours',
  LAST_2_HOURS = 'last_2_hours',
  LAST_4_HOURS = 'last_4_hours',
  LAST_8_HOURS = 'last_8_hours',
  LAST_12_HOURS = 'last_12_hours',
  TODAY = 'today',
  LAST_DAY = 'last_day',
  THIS_WEEK = 'this_week',
  LAST_WEEK = 'last_week',
  LAST_7_DAYS = 'last_7_days',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  LAST_30_DAYS = 'last_30_days',
  THIS_QUARTER = 'this_quarter',
  LAST_90_DAYS = 'last_90_days',
  THIS_YEAR = 'this_year',
  LAST_365_DAYS = 'last_365_days',
  ALL_TIME = 'all_time',
  CUSTOM = 'custom',
}

export const DEFAULT_JOB_DASHBOARD_RANGE = JobDashboardRange.LAST_7_DAYS;

export interface JobDashboardConfiguration {
  dataConnectionIds?: string[];
  title?: string;
  description?: string;
  range: JobDashboardRange;
  from?: Dayjs;
  to?: Dayjs;
}
